import React from 'react';
import Image from "next/image";
import { notFoundImage } from '@/assets/images';
import { FloatValues, storeAssigned } from '@/services/Methods/normalMethods';
import withProductHOC from '@/HOC/withProductHOC';
import _ from 'lodash';
import { useRouter } from 'next/navigation';

// Function to get product descriptions based on product names
const getProductDescription = (title) => {
    const descriptions = {
        'b:flex': 'b:strong. Beauty & mobility from within.',
        'b:clear': 'b:sharp. Unlock mental performance & clarity.',
        'b:base': 'b:grounded. Essential minerals for daily balance.',
        'b:micros': 'b:balanced. Gut health, digestion, and immune support.',
        'b:charged': 'b:energized. Smart. sustained energy.',
        'Blue Energy Blend': 'b:strong. Clean, lasting vitality.',
        'Noni GIA': 'b:pure. Daily renewal from the inside out.',
        'Pink for Women': 'b:fit. Optimized wellness for her.'
    };

    return descriptions[title] || 'Premium wellness product designed for your health.';
};

const ProductSection = ({ allProductState, section = "normal", _addToCartFunction }) => {
    const router = useRouter();

    return (
        <section className="products-section xl:py-20 py-[50px] lg:py-32 bg-white    ">
            <div className="container mx-auto px-[15px]">
                {/* Header Section */}
                <div className="flex items-start justify-between mb-16 lg:flex-row flex-col  lg:items-start items-center">
                    <div className="flex-1">
                        <h2 className="xl:text-[55px] lg:text-[40px] text-[30px] font-semibold text-black mb-6 lg:text-left text-center">
                            wellness that moves with you
                        </h2>
                        <p className="text-[18px] text-black max-w-2xl lg:text-start text-center">
                            Every product in the b:hip range is designed around a state of being. What's your b:? Choose yours.
                        </p>
                    </div>
                    <div className="lg:ml-8 lg:mt-0 mt-8">
                        <button className="flex items-center gap-2 bg-[#0388c7] hover:bg-[#016fa1] text-white p-[9px_9px_9px_30px] rounded-[50px] !no-underline font-bold transition-all duration-300 text-[16px] xl:text-[22px] md:text-[20px] text-[18px] max-w-[400px] w-full flex justify-center">
                            <span className='flex-1'>shop the collection</span>
                            <span className='inline-block ml-auto xl:w-[40px] w-[35px] xl:h-[40px] h-[35px] xl:p-0 xl:p-[10px] p-[6px] rounded-[50%] flex  justify-center items-center bg-white '>
                                {/* <svg className="w-10 h-10" fill="none" stroke="#0388c7" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                                </svg> */}
                                <img src="/images/cart-mian.png" alt="" />
                            </span>
                        </button>
                    </div>
                </div>

                {/* Product Grid */}
                <div className="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-[25px]">
                    {allProductState?.length > 0 ? (
                        _.map(allProductState.slice(0, 8), ({ id, image, title, normal_oneTime, category_id }, index) => (
                            <div key={index} className="bg-[#f5f7fc] rounded-[30px] 2xl:p-[30px] p-[15px] shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden h-[100%]">
                                <div
                                    className="cursor-pointer flex flex-col h-[100%]"
                                    onClick={() => {
                                        window.location.assign(`${storeAssigned()}/products/${id}/${_.lowerCase(title).replace(' ', '_')}`)
                                    }}
                                >
                                    <div className="relative overflow-hidden p-6 bg-white rounded-[30px]">
                                        {(image) ? (
                                            <img
                                                src={image}
                                                alt={title}
                                                className="w-full h-48 object-contain mx-auto"
                                            />
                                        ) : (
                                            <div className="w-full h-48 bg-gray-100 flex items-center justify-center rounded-lg">
                                                <Image
                                                    src={notFoundImage}
                                                    alt="Product Image"
                                                    className="w-24 h-24 object-contain opacity-50"
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="pt-[20px] flex-1 flex flex-col">
                                        <h3 className="text-[25px] font-semibold text-black mb-2">
                                            {title}
                                        </h3>

                                        <p className="text-[16px] text-black mb-4 font-normal   ">
                                            {getProductDescription(title)}
                                        </p>

                                        <div className="flex justify-end mt-auto">
                                            <button
                                                className="w-12 h-12 bg-[#009cd2] text-white rounded-full flex items-center justify-center hover:bg-[#0088b8] transition-colors duration-300"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (process.env.NEXT_PUBLIC_COMING_SOON !== 'true') {
                                                        _addToCartFunction(id, 'oneTime', category_id);
                                                    }
                                                }}
                                            >
                                                {/* <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                                                </svg> */}
                                                <img src="/images/cart-plus.png" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-span-full text-center py-12">
                            <p className="text-gray-500">Loading products...</p>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default withProductHOC(ProductSection, 'normal');
